var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#96CEFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#B5DEFF",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3337 12.0127V14.7664C19.3337 15.1398 19.3337 15.3264 19.4063 15.469C19.4702 15.5945 19.5722 15.6965 19.6977 15.7604C19.8403 15.8331 20.027 15.8331 20.4003 15.8331H23.154M19.3337 21.833H15.3337M20.667 19.1663H15.3337M23.3337 17.1585V21.9663C23.3337 23.0864 23.3337 23.6465 23.1157 24.0743C22.9239 24.4506 22.618 24.7566 22.2416 24.9484C21.8138 25.1663 21.2538 25.1663 20.1337 25.1663H15.867C14.7469 25.1663 14.1868 25.1663 13.759 24.9484C13.3827 24.7566 13.0767 24.4506 12.885 24.0743C12.667 23.6465 12.667 23.0864 12.667 21.9663V15.033C12.667 13.9129 12.667 13.3529 12.885 12.925C13.0767 12.5487 13.3827 12.2427 13.759 12.051C14.1868 11.833 14.7469 11.833 15.867 11.833H18.0082C18.4974 11.833 18.7419 11.833 18.9721 11.8883C19.1762 11.9373 19.3713 12.0181 19.5502 12.1277C19.7521 12.2514 19.925 12.4244 20.2709 12.7703L22.3964 14.8957C22.7423 15.2417 22.9153 15.4146 23.0389 15.6164C23.1486 15.7954 23.2294 15.9905 23.2784 16.1945C23.3337 16.4247 23.3337 16.6693 23.3337 17.1585Z",
    stroke: "#0265DC",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/forms.407655d544163ed252aba2c7dbcb934f.svg";
export { ForwardRef as ReactComponent };